import script from "./RawMaterialTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RawMaterialTable.vue?vue&type=script&setup=true&lang=js"

import "./RawMaterialTable.vue?vue&type=style&index=0&id=513c5a18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-513c5a18"]])

export default __exports__